export default __webpack_public_path__ + "static/media/Plissee ausmessen front.10f3c96b.jpg";